/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ThreadsControllerFindOneQueryResponse, ThreadsControllerFindOnePathParams, ThreadsControllerFindOne401, ThreadsControllerFindOne403, ThreadsControllerFindOne404 } from "../../models/threadsController/ThreadsControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { threadsControllerFindOne } from "../../clients/threadsService/threadsControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const threadsControllerFindOneQueryKey = (threadId: ThreadsControllerFindOnePathParams["threadId"]) => [{
  url: '/api/v1/threads/:threadId',
  params: {
    threadId: threadId
  }
}] as const;
export type ThreadsControllerFindOneQueryKey = ReturnType<typeof threadsControllerFindOneQueryKey>;
export function threadsControllerFindOneQueryOptions(threadId: ThreadsControllerFindOnePathParams["threadId"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = threadsControllerFindOneQueryKey(threadId);
  return queryOptions<ThreadsControllerFindOneQueryResponse, ResponseErrorConfig<ThreadsControllerFindOne401 | ThreadsControllerFindOne403 | ThreadsControllerFindOne404>, ThreadsControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!threadId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return threadsControllerFindOne(threadId, config);
    }
  });
}

/**
 * @description Retrieve detailed information about a specific thread.
 * @summary Get a single thread
 * {@link /api/v1/threads/:threadId}
 */
export function useThreadsControllerFindOne<TData = ThreadsControllerFindOneQueryResponse, TQueryData = ThreadsControllerFindOneQueryResponse, TQueryKey extends QueryKey = ThreadsControllerFindOneQueryKey>(threadId: ThreadsControllerFindOnePathParams["threadId"], options: {
  query?: Partial<QueryObserverOptions<ThreadsControllerFindOneQueryResponse, ResponseErrorConfig<ThreadsControllerFindOne401 | ThreadsControllerFindOne403 | ThreadsControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? threadsControllerFindOneQueryKey(threadId);
  const query = useQuery({
    ...threadsControllerFindOneQueryOptions(threadId, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ThreadsControllerFindOne401 | ThreadsControllerFindOne403 | ThreadsControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}